import styled, { css } from 'styled-components';
import { Colors } from '../../../styles/colors';
import { media } from '../../../styles/media';
import { JobDescriptionStatisticProps } from './JobDescriptionStatistic.types';

export const Container = styled.div<JobDescriptionStatisticProps>`
  padding: 16px 0;
`;
